<script>
import { nextTick } from 'vue'
import TableMainCheckbox from '@/components/DataTables/TableMainCheckbox'
import TableFilterStar from '@/components/DataTables/Filters/TableFilterStar'
import CheckboxRow from '@/components/Forms/CheckboxRow'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import Snackbar from '@/components/Messages/Snackbar'
import { getPokerPositions } from '@/store/gamestate/gamestate'
import { throttle } from 'lodash'
import { numRoundTo5bb, SNK } from '@/helpers/helpers'
import CustomScrollbar from '@/components/lib/CustomScrollbar'
import format_mix from '@/mixins/format_mix'
import InfiniteFlexTable from '@/components/lib/InfiniteFlexTable'
import float_mix from '@/mixins/float_mix'
import { getTableColumnKeys } from '@/store/gameformat/gameformat'
import { namespaces } from '@/helpers/constants'
import GwTooltip from '@/components/lib/GwTooltip'
import TableFilterStream from '@/components/DataTables/Filters/TableFilterStream'
import GmfSelectorFilter from './GmfSelectorFilter.vue'

export default {
  name: 'GmfSelectorStacksTable',
  components: {
    CustomScrollbar,
    InfiniteFlexTable,
    TableMainCheckbox,
    TableFilterStar,
    CheckboxRow,
    Checkbox,
    Snackbar,
    GwTooltip,
    TableFilterStream,
    GmfSelectorFilter,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { String, required: true },
    conf: Object,
    gameformat: Object,
    hasMultiselect: { type: Boolean, default: true },

    instaApply: Boolean,
    routerParams: Object,
    keepHistoryTree: Boolean,
    hasLists: Boolean,
    channelId: String,

    hasKeydown: Boolean,
    hasLock: Boolean,

    hasSTR: Boolean,
    hasSTRpreflop: Boolean,
    hasAvgStackCell: { type: Boolean, default: true },
    avgStackRow: Boolean,
    stacksRow: Boolean,
    depthRow: Boolean,
    isCash3456789HuMaxSTRpreflop: Boolean,
    isCashShortstack: Boolean,
    isCashHu: Boolean,
    isAnte4max: Boolean,
    isCash9max: Boolean,
    isCash6max: Boolean,
    showStackRounding: Boolean,
    isPreflopOnly: Boolean,
    // cssClass: { default: '' },
    isICMEvents: Boolean,
  },
  emits: ['table:click', 'gmf:update'],
  data() {
    return {
      scrolledPercentY: 0,
      touched: false,
      tooltip: {
        type: 'bounty',
        visible: false,
        bounties: [],
        playerName: '',
        style: '',
      },
    }
  },
  mounted() {
    this.scrollToActiveGmf()
  },
  beforeUnmount() {
    this.removeTooltipHideListeners()
  },
  methods: {
    handleSort(idx) {
      if (this.sortKey === idx) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = idx
        this.sortOrder = 'asc'
      }
      this.scrollToActiveGmf()
    },
    getNextGameformat(num) {
      const tableRows = this.tRows
      const idx = tableRows.findIndex(i => i.active)
      let nextIdx = idx + num
      const l = tableRows.length - 1
      nextIdx = nextIdx > l ? 0 : nextIdx < 0 ? l : nextIdx
      const res = tableRows[nextIdx]
      this.selectItem(res)
    },
    toggleAll() {
      const allSelected = this.mainCheckboxValue === 'all'
      this.updateList({
        empty: allSelected,
        fill: !allSelected,
      })
    },
    emptyAll() {
      this.updateList({
        empty: true,
      })
    },
    handleComfyItemClick(id) {
      let row = []

      if (this.showStackRounding) {
        row = this.tRows.find(i => i.displayCells.includes(id))
      } else {
        row = this.tRows.find(i => i.row_id === id)
      }
      this.toggleRow(row)
    },
    toggleRow(ii) {
      this.$emit('table:click')

      this.touched = true
      if (this.hasMultiselect) {
        this.updateList({
          value: ii.row_id,
        })
        if (!ii.selected) {
          this.selectItem(ii)
          return
        }
        const firstSelected =
          this.tRows.find(i => i.row_id !== ii.row_id && i.selected) || this.tRows[0]
        this.selectItem(firstSelected)
        return
      }
      this.selectItem(ii)
    },
    listCheck() {
      if (!this.hasMultiselect) return
      const key = 'row_id'
      const selectedList = this.selectedList.filter(id => this.tRows.some(i => i[key] === id))
      if (JSON.stringify(this.selectedList) !== JSON.stringify(selectedList)) {
        this.updateList({
          list: selectedList,
        })
      }
    },
    updateList(listArgs) {
      // for trainer
      const applyArgs = {
        instaApply: this.instaApply,
        routerParams: this.routerParams,
        hasLists: this.hasLists,
        channelId: this.channelId,
      }
      this.$store.dispatch(SNK('gmfs_toggle_list', this.namespace), {
        listKey: this.listKey,
        ...listArgs,
        ...applyArgs,
      })
    },
    selectItem(ii) {
      if (!ii) {
        console.log(ii)
        debugger
        return
      }
      if (ii.active) return
      if (this.keepHistoryTree) {
        this.$store.dispatch('globals_action', 'disable_history_watcher')
        setTimeout(() => {
          this.$store.dispatch(SNK('gmfs_set_tableRow', this.namespace), {
            item: ii,
            instaApply: this.instaApply,
            routerParams: this.routerParams,
            keepHistoryTree: this.keepHistoryTree,
            hasLists: this.hasLists,
            channelId: this.channelId,
          })

          this.$emit('gmf:update', ii)
        })
        return
      }
      this.$store.dispatch(SNK('gmfs_set_tableRow', this.namespace), {
        item: ii,
        instaApply: this.instaApply,
        routerParams: this.routerParams,
        keepHistoryTree: this.keepHistoryTree,
        hasLists: this.hasLists,
        channelId: this.channelId,
      })
      this.$emit('gmf:update', ii)
    },
    toggleFilterfavorite(bool) {
      this.selectedFilters = {
        ...this.selectedFilters,
        favorite: bool ?? !this.selectedFilters.favorite,
      }
      this.performChecks()
    },
    toggleStreamsFilter(bool) {
      this.selectedFilters = {
        ...this.selectedFilters,
        streams: bool ?? !this.selectedFilters.streams,
      }
      this.performChecks()
    },
    handleFilterUpdate(item) {
      const res = {
        ...this.selectedFilters,
        [item.id]: item.selected,
      }
      if (JSON.stringify(res) === JSON.stringify(this.selectedFilters)) return
      this.selectedFilters = res
      this.performChecks()
    },
    performChecks(e) {
      if (this.touched) {
        this.touched = false
        return
      }
      this.sortCheck()
      this.listCheck()
      this.activeGmfCheck()
      this.scrollToActiveGmf()
    },
    sortCheck() {
      if (!this.tRows[0]?.cells?.[this.sortKey]) {
        this.sortKey = 0
      }
    },
    activeGmfCheck() {
      if (!this.tRows.length) return // filters not initialized yet betwen group switching
      if (!this.tRows.some(tr => tr.active)) {
        this.selectItem(this.tRows[0])
      }
    },
    scrollToActiveGmf({ times = 0 } = {}) {
      nextTick(() => {
        const activeRowEl = document.getElementById('gmf-row-active')
        const scrollerEl = this.$refs?.inftable?.$refs?.scroller?.$el
        if (activeRowEl && scrollerEl) {
          const observer = new IntersectionObserver(
            entries => {
              if (entries[0].intersectionRatio < 0.5) {
                this.scrollToIndex(times)
              }
              observer.unobserve(activeRowEl)
            },
            {
              root: scrollerEl,
              rootMargin: '0px',
              threshold: 1,
            },
          )
          observer.observe(activeRowEl)
          return
        }
        this.scrollToIndex(times)
      })
    },
    scrollToIndex(times) {
      const idx = this.tRows.findIndex(tr => tr.active)
      const scroller = this.$refs?.inftable?.$refs?.scroller
      if (!scroller || idx === -1) return
      scroller.scrollToIndex(idx)

      if (times > 3) return
      this.scrollToActiveGmf({ times: times + 1 })
    },
    getOptionName({ option, row }) {
      const res = row.getOptionName
        ? row.getOptionName({ option, row, rows: this.tRows, scope: this })
        : option.id
      return res
    },
    getComfyName(id) {
      const res = this.showStackRounding
        ? id
        : this.depthRow || this.avgStackRow
          ? this.numRoundTo5bb(id)
          : this.stacksRow
            ? id
                .split('-')
                .map(i => numRoundTo5bb(Number(i)))
                .join('-')
            : id
      return res
    },
    handleScroll: throttle(function ({ e, scroller }) {
      const { scrollTop, scrollHeight, clientHeight } = scroller
      this.scrolledPercentY = scrollTop / (scrollHeight - clientHeight)
      this.hideTooltip()
    }, 1),
    handleScrollbarUpdate({ percentY } = {}) {
      const scroller = this.$refs?.inftable?.$refs?.scroller?.$el
      if (scroller) {
        const { scrollHeight, clientHeight } = scroller
        const res = (scrollHeight - clientHeight) * percentY
        scroller.scrollTop = res
      }
    },
    togglefavorite(row, index) {
      const gameformats = row.gameformats ? row.gameformats : [row]
      this.$store.dispatch('gameformats_set_favorite', { gameformats })
    },
    showTooltip({ e, row, index, type }) {
      const playerNames = row.gameformats?.[0]?.player_names
      const bounties = row.gameformats?.[0]?.bounties

      if (type === 'playerName') {
        if (!playerNames || isNaN(row.displayCells[index]) || index < 2) {
          this.hideTooltip()
          return
        }
        this.showPlayerNameTooltip({ e, row, index, playerNames })
      } else if (type === 'bounty') {
        if (!bounties || playerNames) {
          this.hideTooltip()
          return
        }
        this.showBountyTooltip({ e, index, bounties })
      } else {
        console.warn('Unknown tooltip type', type)
        this.hideTooltip()
      }
    },
    showPlayerNameTooltip({ e, row, index, playerNames }) {
      // Count how many times there is an empty cell up until the hovered cell
      const emptyCellsTillHoveredCell = row.displayCells
        .slice(0, index)
        .filter(c => isNaN(c)).length
      // To get an index for name we must subtract columns for hand number and avg columns
      const playerNameIndex = index - emptyCellsTillHoveredCell - 2
      const playerName = playerNames[playerNameIndex]

      this.tooltip = {
        type: 'playerName',
        visible: true,
        style: '',
        bounties: [],
        playerName,
      }

      this.positionTooltip({ e })
    },
    showBountyTooltip({ e, index, bounties }) {
      const cell = document.getElementById(`tdcell_1_${index}`)
      const cellWidth = cell?.getBoundingClientRect()?.width
      if (!cellWidth) return

      this.tooltip = {
        type: 'bounty',
        visible: true,
        style: `min-width: ${cellWidth * bounties.length}px`,
        bounties,
        playerName: '',
      }

      this.positionTooltip({ e })
    },
    positionTooltip({ e }) {
      const element = this.$refs.tooltip
      const referenceEl = e.currentTarget
      const boundary = this.$refs.inftable?.$el
      const options = {
        offset: -2,
        padding: 0,
        placement: 'top-end',
        strategy: 'fixed',
      }
      if (referenceEl && element) {
        this.fl_setPositionStyle({ referenceEl, boundary, element, options })
      }
      setTimeout(() => {
        this.addTooltipHideListeners()
      }, 80)
    },
    hideTooltip({ type } = {}) {
      if (this.tooltip.visible && this.tooltip.type === type) {
        this.tooltip.visible = false
        this.removeTooltipHideListeners()
      }
    },
    addTooltipHideListeners() {
      window.addEventListener('touchstart', this.hideTooltip)
    },
    removeTooltipHideListeners() {
      window.removeEventListener('touchstart', this.hideTooltip)
    },
    switchToStreamTab() {
      this.$store.dispatch('switchers_set_item', {
        key: 'sw_tabs_tabletile_icm_events',
        item: { payload: 'stream_url' },
      })
    },
    setActiveICMFilters(filters) {
      this.$store.dispatch(SNK('gmfs_set', this.namespace), {
        key: 'gmfs_table_activeICMFilters',
        value: filters,
      })
    },
    setInputsOpen(inputsOpen) {
      this.$store.dispatch(SNK('gmfs_set', this.namespace), {
        key: 'gmfs_table_inputsOpen',
        value: inputsOpen,
      })
    },

    getTitleTooltip(i) {
      if (i.tooltipHtml) {
        return i.tooltipHtml
      }
      if (i.title_tooltip) {
        return this.$t(i.title_tooltip)
      }
      return ''
    },
  },
  computed: {
    gmfs() {
      switch (this.namespace) {
        case namespaces.STUDY:
          return this.$store.state.study.gmf_selektor
        case namespaces.REPORTS:
          return this.$store.state.rep.gmf_selektor
        case 'solfigr':
          return this.$store.state.solfigr.gmf_selektor
        case 'tmp/primary':
          return this.$store.state.tmp.primary.gmf_selektor
        case 'tmp/secondary':
          return this.$store.state.tmp.secondary.gmf_selektor
        case 'tmp/extra1':
          return this.$store.state.tmp.extra1.gmf_selektor
        case 'tmp/extra2':
          return this.$store.state.tmp.extra2.gmf_selektor
        case 'tmp/extra3':
          return this.$store.state.tmp.extra3.gmf_selektor
        default:
          return this.$store.state.gmf_selektor
      }
    },
    hasComfyView() {
      return ['PracticeTrainer', 'PracticeDrills'].includes(this.$route.name) &&
        this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}fh_start_spot`] !==
          'custom_spot'
        ? true
        : this.isCash3456789HuMaxSTRpreflop
          ? false
          : this.gameformat?.format === 'icm'
            ? false
            : this.gameformat?.format === 'icm_events'
              ? false
              : this.gameformat?.format === 'chipev'
                ? this.gameformat?.players === 8 &&
                  this.gameformat?.solution_completeness === 'all_spots'
                : true
    },
    gmfStacksTableAsGrid: {
      get() {
        return this.hasComfyView && this.$store.getters.mergedUserSettings.gmfStacksTableAsGrid
      },
      set(value) {
        this.$store.dispatch('userSettings', { gmfStacksTableAsGrid: value })
        // share this across windows
        this.$store.dispatch('bc_postMessage', {
          channelId: 'app',
          data: {
            code: 'settings_udpdate',
            value: { gmfStacksTableAsGrid: value },
          },
        })
      },
    },
    selectedFilters: {
      get() {
        return this.gmfs.gmfs_table_selectedFilters
      },
      set(v) {
        this.gmfs.gmfs_table_selectedFilters = v
      },
    },
    inputsOpen: {
      get() {
        return this.$store.getters[SNK('gmfs_table_inputsOpen', this.namespace)]
      },
      set(val) {
        this.$store.dispatch('gmfs_set', {
          key: 'gmfs_table_inputsOpen',
          value: val,
        })
      },
    },
    sortKey: {
      get() {
        return this.gmfs.gmfs_table_sortKey
      },
      set(v) {
        this.gmfs.gmfs_table_sortKey = v
        if (this.instaApply) {
          this.$store.dispatch('gmfs_apply', {
            routerParams: this.routerParams,
            channelId: this.channelId,
          })
        }
      },
    },
    sortOrder: {
      get() {
        return this.gmfs.gmfs_table_sortOrder
      },
      set(v) {
        this.gmfs.gmfs_table_sortOrder = v
        this.$store.dispatch('gmfs_update_detached', { channelId: this.channelId })
      },
    },
    listKey() {
      return this.avgStackRow
        ? 'gmfs_avgStackList'
        : this.depthRow
          ? 'gmfs_depthList'
          : 'gmfs_stacksList'
    },
    selectedList() {
      return this.gmfs[this.listKey]
    },
    tbFilters() {
      let res =
        this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gmfs_tableFilters`]
      res = res.map(i => ({
        ...i,
        title: this.$t(i.title),
        das: i.title_tooltip,
        title_tooltip: this.getTitleTooltip(i),
      }))
      return res
    },
    gmfFavoriteIds() {
      return this.$store.getters.gameformats_favorite_ids
    },
    hasFavorites() {
      return this.hasMultiselect || !this.gmfFavoriteIds.length
        ? false
        : !!this.tRows.some(i => i.is_favorite)
    },
    hasStreams() {
      return this.tRows.some(i => i.hasStream)
    },
    tRows() {
      let res = this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gmfs_tableRows`]

      if (this.isICMEvents && ['StudySolutions'].includes(this.$route.name)) {
        res.forEach(row => {
          // cells already contain hand_number and avg_stack values so we need subtract two to get the actual players count
          const rowPositions = getPokerPositions({
            gameformat: { players: row.cells.length - 2, format: 'icm_events' },
          })
          // create a mask placing false where the current row positions don't exist compared starting positions of event
          const mask = [true, true, ...this.positions.map(value => rowPositions.includes(value))]
          // replace true in the mask with values from current row and fill the rest with dashes (or empty style in cell styles)
          let cell_i = 0
          row.displayCells = mask.map(m => (m ? row.displayCells[cell_i++] : '-'))
          let cell_style_i = 0
          row.cellStyles = mask.map(m => (m ? row.cellStyles[cell_style_i++] : ''))

          row.hasStream = !!row.gameformats?.[0]?.stream_url
        })
      }

      if (this.isCash3456789HuMaxSTRpreflop && !this.isCashShortstack) {
        // if (!this.hasMultiselect && this.isCash3456789HuMaxSTRpreflop && !this.isCashShortstack) {
        res = res.map(i => ({
          ...i,
          displayCells: i.displayCells.map((cc, idx) =>
            cc === 'no_cash_drop'
              ? '-'
              : idx === 0 || this.stacksRow
                ? cc
                : cc
                  ? this.$t(`gametypes.${cc}`)
                  : '-',
          ),
        }))
      }

      // icm filters set with gmfselektorfilter component
      if (this.gameformat.group === 'mtt' && this.gameformat.format === 'icm') {
        // filter based on min/max stack for each position
        const gametype = `${this.gameformat.format}${this.gameformat.players}${this.gameformat.tournament_type}${this.gameformat.tournament_players}${this.gameformat.tournament_phase}`
        res = res.filter(row => {
          const gmf = row.gameformats?.[0]
          if (!gmf?.stacks) return true // when stacks are missing, do not filter (keep the row)

          const stacks = gmf.stacks.split('-').map(i => numRoundTo5bb(parseInt(i, 10)))
          return this.gmfs.gmfs_table_activeICMFilters
            .filter(af => this.positions.includes(af.position) && af.gametype === gametype)
            .every(af => {
              const idx = this.positions.findIndex(p => p === af.position)
              const stack = stacks[idx]
              return stack >= af.minStack && stack <= af.maxStack
            })
        })

        // filter based on avg stack
        res = res.filter(row => {
          const rowAvg = numRoundTo5bb(parseInt(row.avgStack, 10))
          const avgFilter = this.gmfs.gmfs_table_activeICMFilters.find(
            af => af.position === 'Avg.' && af.gametype === gametype,
          )
          if (avgFilter) {
            return rowAvg >= avgFilter?.minStack && rowAvg <= avgFilter?.maxStack
          }
          return true
        })
      }

      return res
    },
    comfyRows() {
      let options = []
      if (this.showStackRounding) {
        options = this.tRows.map(i => i.display_stack_rounding)
      } else {
        options = this.tRows.map(i => i.row_id)
      }
      const locks = this.tRows.map(i => i.hasLock)
      // console.log(this.tRows)
      let selected = []
      if (this.hasMultiselect) {
        if (this.showStackRounding) {
          selected = this.tRows.filter(i => i.selected).map(i => i.display_stack_rounding)
        } else {
          selected = this.tRows.filter(i => i.selected).map(i => i.row_id)
        }
      } else {
        selected = this.tRows.filter(i => i.active).map(i => i.row_id)
      }

      const css_class =
        this.gameformat.group === 'cash' || this.tRows.length < 7 ? '' : 'cherow_grid'
      const res = {
        title: '',
        id: 'comfyRows',
        options,
        selected,
        locks,
        css_class,
        style: `
        ${
          !css_class
            ? ''
            : this.avgStackRow
              ? '--columns-items-row: repeat(auto-fit, minmax(3.25em, 1fr));'
              : this.hasAvgStackCell
                ? `--columns-items-row: repeat(auto-fit, minmax(${
                    this.gameformat.players * 1.75
                  }em, 1fr));`
                : this.stacksRow
                  ? '--columns-items-row: repeat(auto-fit, minmax(7em, 1fr));'
                  : '--columns-items-row: repeat(auto-fit, minmax(3.25em, 1fr));'
        }
          ${
            this.hasMultiselect
              ? ''
              : '--clr-btn-back: var(--clr-black-2);--clr-row-back: var(--clr-black-2);'
          }`,
      }
      return res
    },
    avgStacks() {
      const allStacks = this.tRows.reduce((a, b) => [...a, b.cells[this.sortKey]], [])
      let l = allStacks.length
      let res = allStacks.map((n, index) => ({
        id: n,
        percentTop: index / l,
        index,
      }))

      l = res.length
      const max = l <= 10 ? 3 : l <= 15 ? 4 : l <= 25 ? 5 : l <= 35 ? 6 : 8
      if (l > max) {
        const last = res.pop()
        l -= 1
        const retainIndexes = [...new Array(max).keys()].map((_, idx) =>
          this.numFixed(idx * (l / max)),
        )
        res = res.filter(i => retainIndexes.includes(i.index))
        res.push(last)
      }
      res = res.filter(i => i.id)
      return res
    },
    selectedRows() {
      let res = this.tRows.filter(i => i.selected)
      res = res.length ? res : this.tRows
      return res
    },
    skippedSituations() {
      // duplicates are an array which can contain same values in multiple rows (we want to have each duplicate only once)
      return this.selectedRows
        .flatMap(i => i.gameformats?.[0]?.duplicates || [])
        .reduce((acc, val) => (acc.includes(val) ? acc : [...acc, val]), [])
    },
    mainCheckboxValue() {
      const { length } = this.tRows
      const selectedLength = this.tRows.filter(i => i.selected).length
      if (!selectedLength) {
        return 'none'
      }
      if (selectedLength === length) {
        return 'all'
      }
      return 'indeterminate'
    },
    tableTitle() {
      const titles = {
        cash: {
          title: 'common.solutions',
          title_tooltip: 'tooltips.gmf_cash_stacks',
        },
        mtt: {
          title: 'common.solutions',
        },
        spins: {
          title: 'gameformat.stacks_btn_sb_bb',
          title_tooltip: 'tooltips.gmf_stacks',
        },
        rest: {
          title: 'gameformat.stacks',
          title_tooltip: 'tooltips.gmf_stacks',
        },
        table_grid: {
          title: this.tHead[0].i18nKey,
        },
        none: {
          title: '',
        },
      }

      const key =
        this.conf.conditions.group === 'spins'
          ? 'spins'
          : this.conf.conditions.group === 'cash' && !this.hasMultiselect
            ? this.conf.conditions.cash_type === 'regular'
              ? 'cash'
              : 'rest'
            : 'rest'
      let res = titles[key]

      let gridTitle = null
      if (this.gmfStacksTableAsGrid) {
        const gKey = this.gmfStacksTableAsGrid && this.tHead.length === 1 ? 'table_grid' : key
        gridTitle = titles[gKey]
      }

      const noTitle =
        this.gmfStacksTableAsGrid || this.isCash3456789HuMaxSTRpreflop
          ? false
          : this.avgStackRow || this.depthRow

      res = {
        title: noTitle ? '' : gridTitle ? this.$t(gridTitle.title) : this.$t(res.title),
        title_tooltip: this.$t(res.title_tooltip),
      }
      return res
    },
    positions() {
      // in icm events we do not have a constant player count for all gameformats
      // to show all player columns correctly we need get positions from the gameformat with the most players
      // for all other cases we can just use the first gameformat
      const gameformat = this.isICMEvents
        ? this.conf.gameformats.reduce(
            (selected, current) => (current.players > selected.players ? current : selected),
            this.conf.gameformats[0],
          )
        : this.conf.gameformats[0]
      return getPokerPositions({ gameformat })
    },
    tHead() {
      let res = null
      // (this.isCashHu ? this.isPreflopOnly : true) &&
      if (
        this.isCash3456789HuMaxSTRpreflop &&
        !this.isCashShortstack &&
        !this.stacksRow &&
        !this.hasMultiselect &&
        !this.hasAvgStackCell
      ) {
        const allColumns = [
          { colKey: 'stack_rounding', id: 'depth', name: this.$t('gameformat.stack') },
          { colKey: 'type', id: 'type', name: this.$t('gameformat.type') },
          { colKey: 'rake', id: 'rake', name: this.$t('gameformat.rake') },
          {
            colKey: 'opening_size',
            id: 'opening_size',
            name: this.$t('gameformat.opening_size_abbr'),
          },
          { colKey: '_3bet_size', id: '_3bet_size', name: this.$t('gameformat._3bet_size_abbr') },
          {
            colKey: 'simplified_position',
            id: 'simplified_position',
            name: this.$t('gameformat.simplified_position_abbr'),
          },
          { colKey: 'cash_drop', id: 'cash_drop', name: this.$t('gameformat.cash_drop') },
          { colKey: 'variant', id: 'variant', name: this.$t('gameformat.variant') },
        ]
        const columnKeys = getTableColumnKeys({
          isPreflopOnly: this.isPreflopOnly,
          isCash6max: this.isCash6max,
          isCash9max: this.isCash9max,
          isCashHu: this.isCashHu,
          isAnte4max: this.isAnte4max,
        })
        res = allColumns
          .filter(i => columnKeys.includes(i.colKey))
          .sort((a, b) => columnKeys.indexOf(a.colKey) - columnKeys.indexOf(b.colKey))
      } else {
        let positions = this.positions.map(p => ({
          id: p,
          name: this.getPlayerHtmlPosition(p),
        }))

        if (this.depthRow && !this.stacksRow && !this.hasAvgStackCell) {
          res = [
            {
              id: 'effective_stack',
              i18nKey: 'common.effective_stack',
              name: this.$t('common.effective_stack'),
            },
          ]
        } else if (this.avgStackRow) {
          res = [
            {
              id: 'avg_stack',
              i18nKey: 'common.average_stack',
              name: this.$t('common.average_stack'),
            },
          ]
        } else {
          res = [
            ...(this.isICMEvents
              ? [{ id: 'tournament_hand_number', name: this.$t('common.hand_num') }]
              : []),
            ...(this.hasAvgStackCell
              ? [
                  {
                    id: 'avg_stack',
                    name: this.$t('common.avg'),
                  },
                ]
              : []),
            ...positions,
          ]
        }
      }
      res = res.map(i => ({ ...i, hasSort: true }))
      return res
    },
    hotkeysPressedBottom() {
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    hasFavorites(bool) {
      if (!bool) {
        this.toggleFilterfavorite(false)
      }
    },
    gameformat: {
      immediate: false,
      handler: 'performChecks',
    },
    hotkeysPressedBottom(keys) {
      if (!this.hasKeydown) return
      if (this.hasMultiselect) return
      if (!keys) return
      const hotkeyActions = {
        nextFormat: {
          keys: ['arrowdown'],
          fn: () => this.getNextGameformat(1),
          hasPreventDefault: true,
        },
        prevFormat: {
          keys: ['arrowup'],
          fn: () => this.getNextGameformat(-1),
          hasPreventDefault: true,
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>

<template>
  <div
    class="gmfstckstbl"
    :class="{ gmfstckstbl_table_centered: tHead.length === 1 }"
  >
    <slot name="before"></slot>
    <div
      v-if="tbFilters.length"
      class="gmfstckstbl_checkbox-row_wrapper"
    >
      <CheckboxRow
        v-for="item in tbFilters"
        :key="item.id"
        :item="item"
        class="gmfstckstbl_checkbox-row"
        :hasAny="item.hasAny"
        :isSingle="item.isSingle"
        :class="item.css_class"
        :style="
          item.isSingle
            ? '--clr-btn-back: var(--clr-black-2);--clr-row-back: var(--clr-black-2);'
            : ''
        "
        :checkboxAs="'btn'"
        @update="item => handleFilterUpdate(item)"
      >
        <template #title_after>
          <div
            v-if="item.help_dialog"
            class="gw_btn ml-2"
            style="
              height: 1.5em;
              font-size: 0.75rem;
              --clr: var(--clr-grey-2);
              --clr-hover: var(--clr-white-0);
            "
            @click="$store.dispatch('router_set_dialogs', item.help_dialog)"
          >
            {{ $t('common.how_it_works') }}
          </div>
        </template>
        <template #default="v">
          {{ !v.id ? '-??-' : getOptionName({ option: v, row: item }) }}

          <div
            v-if="item.locks[v.index]"
            class="mdi mdi-lock text-medium"
            style="position: relative; right: -0.25em"
          ></div>
        </template>
      </CheckboxRow>
    </div>
    <Snackbar
      v-if="gameformat && $route.name === 'StudySolutions' ? gameformat.simplified_position : false"
      ref="snackbar"
      :oneTimeOnly="true"
      localKey="gmf_cash69_simplified_tip"
      class="d-flex w-100 mb-2"
      style="
        --position: relative;
        --clr-back: #317c9b4d;
        padding: 0.5rem 1rem;
        --close-inset: 0.125rem 0.125rem auto auto;
        max-width: 100%;
        --close-padding: 0.25rem;
        --close-size: 1rem;
      "
    >
      <div class="d-flex clr-blue text-small">
        {{ $t('tooltips.tip_simplified_cash') }}
        <div
          class="mdi mdi-help-circle csst ml-1"
          @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'top' })"
        >
          <div
            class="csst_content clr-white"
            style="position: fixed"
            v-html="$t('tooltips.gmf_simplified_position')"
          ></div>
        </div>
      </div>
    </Snackbar>
    <template v-if="$store.getters.user_has_flag('FINAL_TABLE_ICM')">
      <GmfSelectorFilter
        v-if="!hasComfyView && gameformat.group === 'mtt' && gameformat.format === 'icm'"
        style="margin: 0 0 1em 0"
        :gametype="`${gameformat.format}${gameformat.players}${gameformat.tournament_type}${gameformat.tournament_players}${gameformat.tournament_phase}`"
        :rows="tRows"
        :positions="positions"
        :inputsOpen="inputsOpen"
        :activeFilters="gmfs.gmfs_table_activeICMFilters"
        @update:activeFilters="filters => setActiveICMFilters(filters)"
        @update:inputsOpen="inputsOpen => setInputsOpen(inputsOpen)"
      />
    </template>

    <div
      class="clr-grey text-medium d-flex"
      style="margin-bottom: 0.25em"
    >
      <div
        v-if="tableTitle.title"
        class="d-flex gw_hvr"
      >
        {{ tableTitle.title }}

        <div
          v-if="tableTitle.title_tooltip"
          class="position-relative f-center csst"
          style="color: var(--clr-grey-2); --hvr-content-opacity: 0.5"
          @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'top' })"
        >
          <div class="mdi gw_hvr_content mdi-help-circle-outline text-small my-auto ml-1"></div>
          <div
            class="csst_content clr-white text-nowrap"
            style="position: fixed; max-width: clamp(12rem, 36rem, 96vw)"
            v-html="tableTitle.title_tooltip"
          ></div>
        </div>
      </div>

      <div class="ml-auto d-flex">
        {{
          hasMultiselect
            ? $t('common.num_selected_from_num_situations', {
                num_selected: $tc('common.num_selected', selectedRows.length),
                num_situations: $tc('common.num_situations', tRows.length),
              })
            : $tc('common.num_situations', tRows.length)
        }}
        <div
          v-if="skippedSituations.length"
          class="d-flex ml-1"
        >
          {{ $tc('common.skipped_situations', skippedSituations.length) }}
          <GwTooltip
            class="gw_hvr_content ml-1"
            style="--hvr-content-opacity: 0.5"
            :tooltip="
              $tc('tooltips.situations_omitted', {
                duplicates:
                  skippedSituations.length > 8
                    ? '<br/>' +
                      skippedSituations
                        .map(
                          (duplicate, count) =>
                            (count > 0 && count % 8 === 0 ? '<br/>' : '') + duplicate,
                        )
                        .join(', ')
                    : skippedSituations.join(', '),
              })
            "
          />
        </div>
      </div>
      <div
        v-if="hasComfyView"
        class="d-flex"
      >
        <div
          class="ml-1 f-center csst csst_nm gw_btn gw_btn_texts ml-2"
          style="height: 1.325em; --padding: 0.25em"
          @click="gmfStacksTableAsGrid = !gmfStacksTableAsGrid"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
        >
          <div
            class="text-semi-large mdi"
            :class="`${gmfStacksTableAsGrid ? 'mdi-view-sequential' : 'mdi-view-comfy'}`"
          ></div>

          <div
            class="csst_content text-nowrap clr-white"
            style="position: fixed"
          >
            {{
              $t(
                `tooltips.${gmfStacksTableAsGrid ? 'switch_to_table_view' : 'switch_to_grid_view'}`,
              )
            }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="gmfStacksTableAsGrid && comfyRows.options.length > 100"
      style="min-height: 14rem; display: flex"
    >
      <!--refactor 001 checkbox row is not fast enough - probably will have to refactor it or make simpler version like this -->
      <div
        class="gmfstckstbl_checkbox-row d-flex w-100"
        :style="comfyRows.style"
        style="
          min-height: 0px;
          overflow: auto;
          gap: 2px;
          background: var(--clr-row-back);
          border-radius: 4px;
          --clr-btn-back: var(--clr-black-2);
        "
      >
        <div
          v-if="hasMultiselect"
          class="gw_btn"
          style="
            position: sticky;
            top: 0;
            z-index: 2;
            --padding: 0em 0.75em;
            --clr-back: var(--clr-btn-back);
            --brighten-active: 0.125;
            --clr: var(--clr-grey-2);
            --clr-hover: var(--clr-white-0);
            --clr-active: var(--clr-white-0);
            --clr-disabled: var(--clr-black-4);
          "
          :style="
            !comfyRows.selected.length
              ? '--clr: var(--clr-white-0);--clr-hover-white: var(--clr-black-4);--clr-back: var(--clr-black-4)'
              : '--clr-hover-white: var(--clr-black-3)'
          "
          @click="emptyAll"
        >
          {{ $t(`practice.filter.any`) }}
        </div>
        <div
          style="flex: 1; display: grid; grid-template-columns: var(--columns-items-row); gap: 2px"
        >
          <div
            v-for="item in tRows"
            :key="item.id"
            class="gw_btn"
            style="
              --padding: 0em 0.75em;
              --clr-back: var(--clr-btn-back);
              --brighten-active: 0.125;
              --clr: var(--clr-grey-2);
              --clr-hover: var(--clr-white-0);
              --clr-active: var(--clr-white-0);
              --clr-disabled: var(--clr-black-4);
            "
            :style="
              (hasMultiselect ? item.selected : item.active)
                ? `--clr: var(--clr-white-0);
                     --clr-hover-white: var(--clr-black-4);--clr-back: var(--clr-black-4)
                  `
                : '--clr-hover-white: var(--clr-black-3)'
            "
            @click="handleComfyItemClick(item.id)"
          >
            {{ getComfyName(item.row_id) }}
            <span
              v-if="item.hasLock"
              class="mdi mdi-lock text-medium"
              style="position: relative; right: -0.25em"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <!-- refactor 001 -->
    <CheckboxRow
      v-else-if="gmfStacksTableAsGrid"
      :item="comfyRows"
      class="gmfstckstbl_checkbox-row"
      :class="comfyRows.css_class"
      :hasAny="hasMultiselect"
      :isSingle="!hasMultiselect"
      :hasTitle="false"
      :style="comfyRows.style"
      :checkboxAs="'btn'"
      @update:any="emptyAll"
      @update:item="handleComfyItemClick"
    >
      <template #default="v">
        <div>
          {{ getComfyName(v.id)
          }}<span
            v-if="hasSTR || hasSTRpreflop"
            class="text-smallest"
            >bb (<span
              v-html="
                $t('common.stack_str', {
                  str: numRoundTo5bb(v.id / 2),
                })
              "
            />)
          </span>
        </div>
        <div
          v-if="comfyRows.locks[v.index]"
          class="mdi mdi-lock text-medium"
          style="position: relative; right: -0.25em"
        ></div>
      </template>
    </CheckboxRow>

    <div
      v-else
      class="gmfstckstbl_infinite-table_wrapper"
      style="--tbl-row-height: calc(2em + 2px)"
      :style="`min-height:${
        selectedRows.length > 7
          ? 'calc(8 * var(--tbl-row-height) )'
          : `calc(${selectedRows.length} * var(--tbl-row-height)`
      };
       padding-bottom: 0em;
      `"
    >
      <InfiniteFlexTable
        ref="inftable"
        class="gmfstckstbl_table"
        style="
          --row-height: var(--tbl-row-height);
          --clr-body-row-back: var(--clr-black-2);
          --clr-td-back-active: var(--clr-black-2-3);
        "
        :class="[
          { gmfstckstbl_table_multiselect: hasMultiselect },
          `gmfstckstbl_table_group_${gameformat.format}`,
          `gmfstckstbl_table_players_${gameformat.players}`,
        ]"
        :tHead="tHead"
        :tRows="tRows"
        :sortKey="sortKey"
        :sortOrder="sortOrder"
        @visible="scrollToActiveGmf"
        @scroll="handleScroll"
        @th:click="({ item, index }) => handleSort(index)"
      >
        <template #before>
          <div
            ref="tooltip"
            :class="tooltip.visible ? 'gmfstckstbl_tooltip_visible' : ''"
            :style="tooltip.style"
            class="gmfstckstbl_tooltip f-align-center gw_box z-index_4"
            style="
              position: fixed;
              --box-padding: 0;
              --box-height: 1.75em;
              --clr-box-back: var(--clr-black-0);
              --box-radius: 0 4px 4px 0;
            "
          >
            <template v-if="tooltip.type === 'bounty'">
              <div class="gmfstckstbl_tooltip_title px-2">
                <div class="mdi mdi-target gmfstckstbl_tooltip_value_target"></div>
                {{ $t('common.bounties') }}:
              </div>
              <div
                v-for="(bounty, idx) in tooltip.bounties"
                :key="`${bounty}_${idx}_value`"
                class="inftable_td gmfstckstbl_tooltip_value"
              >
                <div class="mdi mdi-target gmfstckstbl_tooltip_value_target"></div>
                {{ numFixedUnit(bounty, 'bounty') }}
              </div>
            </template>
            <template v-if="tooltip.type === 'playerName'">
              <div
                class="inftable_td gmfstckstbl_tooltip_value"
                style="left: 0"
              >
                <div class="mdi mdi-account gmfstckstbl_tooltip_value_target" />
                {{ tooltip.playerName }}
              </div>
            </template>
          </div>
        </template>
        <template #thead_prev>
          <div
            v-if="hasMultiselect"
            class="inftable_th"
            style="--clr-th-back: transparent"
          >
            <TableMainCheckbox
              :indeterminate="mainCheckboxValue === 'indeterminate'"
              :value="mainCheckboxValue === 'all'"
              checkboxStyle="--clr-enabled: var(--clr-white-0)"
              @click="toggleAll"
            />
          </div>
          <div
            v-else
            class="inftable_th inftable_th_star"
            data-tst="gmf_selector_th_star"
            style="--clr-th-back: transparent"
            :class="{ 'no-events opacity_4': !hasFavorites }"
          >
            <TableFilterStar
              :value="hasFavorites ? selectedFilters.favorite : false"
              @input="toggleFilterfavorite"
            />
          </div>
          <div
            v-if="hasStreams"
            class="inftable_th inftable_th_stream"
            data-tst="gmf_selector_th_star"
            style="--clr-th-back: transparent"
          >
            <TableFilterStream
              :value="hasStreams ? selectedFilters.streams : false"
              @input="toggleStreamsFilter"
            />
          </div>
        </template>
        <template #tRow="s">
          <div
            :id="`${s.row.highlighted ? 'gmf-row-active' : ''}`"
            class="inftable_row inftable_body_row"
            :class="`${s.row.highlighted ? 'inftable_body_row_active' : ''}`"
            :data-tst="`gmf_selector_tr_${s.row.gametype}_${s.row.stack_rounding}`"
            @click="
              e => {
                toggleRow(s.row)
                showTooltip({ e, row: s.row, index: s.index, type: 'bounty' })
              }
            "
            @mouseenter="e => showTooltip({ e, row: s.row, index: s.index, type: 'bounty' })"
            @mouseleave="e => hideTooltip({ type: 'bounty' })"
          >
            <div
              v-if="hasMultiselect"
              class="inftable_td"
            >
              <Checkbox
                style="
                  --icon-size: 1.25rem;
                  --clr-disabled: var(--clr-grey-2);
                  --clr-enabled: var(--clr-white-0);
                "
                :value="s.row.highlighted"
              >
              </Checkbox>
            </div>
            <div
              v-else
              class="inftable_td inftable_td_star"
              @click.stop
            >
              <Checkbox
                :data-tst="`gmf_selector_tr_${s.row.gametype}_${s.row.stack_rounding}_star`"
                class="csst csst_nm flgmfslctr_title_controls_item"
                style="
                  --icon-size: 1.25rem;
                  --clr-disabled: var(--clr-grey-2);
                  --clr-enabled: var(--clr-yellow);
                "
                :icons="['mdi-star-outline', 'mdi-star']"
                :value="s.row.is_favorite"
                @click="togglefavorite(s.row, s.index)"
              >
                <template #content>
                  <div
                    class="csst_content text-nowrap clr-white"
                    style="line-height: 1.2; left: calc(100% + 0.5rem)"
                    v-html="$t(`common.${s.row.is_favorite ? 'starred' : 'not_starred'}`)"
                  />
                </template>
              </Checkbox>
            </div>
            <div
              v-if="hasStreams"
              class="inftable_td inftable_td_stream"
              @click.stop
            >
              <Checkbox
                class="csst csst_nm flgmfslctr_title_controls_item"
                style="
                  --icon-size: 1.25rem;
                  --clr-disabled: rgb(254, 0, 0);
                  background: radial-gradient(
                    circle at center,
                    white 0%,
                    white 30%,
                    transparent 30%,
                    transparent 100%
                  );
                "
                :icons="['mdi-youtube']"
                :value="!s.row.hasStream"
                @click="
                  e => {
                    toggleRow(s.row)
                    switchToStreamTab()
                  }
                "
              >
                <template #content>
                  <div
                    class="csst_content text-nowrap clr-white"
                    style="line-height: 1.2; left: calc(100% + 0.5rem)"
                  >
                    {{ $t('common.open_video') }}
                  </div>
                </template>
              </Checkbox>
            </div>
            <div
              v-for="(cell, idx) in s.row.displayCells"
              :id="`tdcell_${idx}_${s.index}`"
              :key="`${cell}_${idx}_${s.index}`"
              class="inftable_td"
              :class="[
                {
                  inftable_td_active: s.sortKey === idx.toString(),
                },
                `gmfstckstbl_table_td_${s.tHead[idx] ? s.tHead[idx].id : ''}`,
              ]"
              :style="s.row.cellStyles[idx]"
              @click="
                e => {
                  showTooltip({ e, row: s.row, index: idx, type: 'playerName' })
                }
              "
              @mouseenter="e => showTooltip({ e, row: s.row, index: idx, type: 'playerName' })"
              @mouseleave="e => hideTooltip({ type: 'playerName' })"
            >
              <div class="position-relative">
                {{ cell
                }}<span
                  v-if="(hasSTR || hasSTRpreflop) && idx === 0"
                  class="text-smallest mt-auto"
                  >bb (<span
                    v-html="
                      $t('common.stack_str', {
                        str: numRoundTo5bb(cell / 2),
                      })
                    "
                  />)
                </span>
                <span
                  v-if="s.row.cellStyles[idx]"
                  class="mdi mdi-menu-down text-large"
                  style="
                    position: absolute;
                    color: var(--clr-dot);
                    transform: rotate(var(--rotate));
                    top: -0.325rem;
                    right: -1.25rem;
                  "
                ></span>
              </div>
              <div
                v-if="idx === 0 && s.row.hasLock"
                class="mdi mdi-lock text-medium"
                style="position: absolute; right: 0.35em"
              ></div>
            </div>
          </div>
        </template>
      </InfiniteFlexTable>
      <CustomScrollbar
        v-if="tRows.length > 10"
        :percent="scrolledPercentY"
        class="gmfstckstbl_scrollbar"
        style="--clr-inner-back: var(--clr-black-2)"
        @update="handleScrollbarUpdate"
      >
        <template #handle_wrapper>
          <div
            class="gmfstckstbl_scrollbar_stacks"
            style="height: 100%; position: relative"
          >
            <div
              v-for="(ii, idx) in avgStacks"
              :key="`${ii.id}_${idx}`"
              class="gmfstckstbl_scrollbar_stacks_stack"
              :style="`top:${ii.percentTop * 100}%`"
            >
              {{ ii.id }}
            </div>
          </div>
        </template>
      </CustomScrollbar>

      <slot name="after_table"></slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<style lang="scss" scoped>
.text-large {
  font-size: 1.5em;
}
.text-semi-large {
  font-size: 1.25em;
}
.text-medium {
  font-size: 0.875em;
}
.text-small {
  font-size: 0.8em;
  line-height: 1.2em;
}
.text-smallest {
  font-size: 0.7em;
}
</style>
<style lang="scss">
.gmfstckstbl {
  display: flex;
  flex-direction: column;
  &_comfy_wrapper {
    max-height: 28em;
    min-height: 4em;
    overflow-y: auto;
    overflow-x: hidden;
    flex-shrink: 0;
  }
  &_checkbox-row_wrapper {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    min-height: 0;
    flex-shrink: 0;
    width: 100%;
    gap: 1em;
    padding-bottom: 1em;
    flex-shrink: 0;
  }
  &_infinite-table_wrapper {
    position: relative;
    display: flex;
    flex: 1;
  }
  &_checkbox-row {
    width: 100%;
    flex-shrink: 0;
    &_width-auto {
      width: auto;
      max-width: 100%;
    }
  }
  &_table {
    flex: 1;
  }
  &_scrollbar {
    width: 2em;
    margin: calc(2em + 2px) 0 0 0.75em;
    &_stacks {
      &_stack {
        position: absolute;
        font-size: 0.7em;
        white-space: nowrap;
        color: var(--clr-grey-2);
        font-weight: 600;
        width: 100%;
        transform: translate(0, -50%);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  &_tooltip {
    pointer-events: none;
    opacity: 0;
    height: 0;
    transition: opacity 0.22s;
    &_visible {
      opacity: 1;
      height: auto;
      overflow: unset;
    }
    border-top: solid 1px var(--clr-black-3);
    border-right: solid 1px var(--clr-black-3);
    border-bottom: solid 1px var(--clr-black-3);

    &_title {
      border-top: solid 1px var(--clr-black-3);
      border-left: solid 1px var(--clr-black-3);
      border-bottom: solid 1px var(--clr-black-3);
      border-radius: 4px 0 0 4px;

      height: calc(100% + 2px);
      position: absolute;
      top: -1px;
      z-index: 1;
      font-size: 0.875em;
      padding: 0 0.5em;
      left: 0;
      transform: translate(-100%);
      background: var(--clr-box-back);
      display: flex;
      align-items: center;
      justify-content: center;

      .gmfstckstbl_tooltip_value_target {
        display: none;
      }
    }
    &_value {
      position: relative;
      height: 100%;
      left: -0.35em;
      display: flex;
      align-items: center;
      font-size: 0.875em;
      &_target {
        border-radius: 4px;
        margin: 0 0.125em 0 0;
      }
    }
  }
}
.gmfstckstbl_table {
  .inftable_td {
    font-weight: 500;
    white-space: nowrap;
  }
  .inftable_th_star,
  .inftable_td_star {
    max-width: 2.5em;
    z-index: 5;
    line-height: 1;
  }
  .inftable_th_stream,
  .inftable_td_stream {
    z-index: 4;
    max-width: 2.5em;
    line-height: 1;
  }
  &_multiselect {
    .inftable_th,
    .inftable_td {
      &:first-child {
        max-width: 2.5em;
        min-width: 2.5em;
        z-index: 4;
      }
    }
  }
  &_centered {
    .inftable_th,
    .inftable_td {
      justify-content: center;
    }
    .inftable {
      --sort-icon-position: relative;
      --sort-icon-right: -0.375em;
    }
  }
  &_players_8 {
    &:not(.gmfstckstbl_table_group_8max_straddle, .gmfstckstbl_table_group_chipev) {
      .inftable_th_avg_stack,
      .gmfstckstbl_table_td_avg_stack {
        min-width: 4em;
      }

      .inftable_th {
        --sort-icon-top: -0.25em;
        --sort-icon-right: -0.5em;
      }
    }
  }
  &_players_9 {
    &:not(.gmfstckstbl_table_group_9max) {
      .inftable_th_avg_stack,
      .gmfstckstbl_table_td_avg_stack {
        min-width: 4em;
      }
      .inftable_th {
        --sort-icon-top: -0.25em;
        --sort-icon-right: -0.5em;
      }
      .inftable_th_UTG\+1,
      .inftable_th_UTG\+2 {
        --th-padding: 0 0.75em 0 0.25em;
      }
    }
  }
  .inftable_th_opening_size {
    --sort-icon-right: -0.5em;
  }

  &:not(.gmfstckstbl_table_multiselect) {
    .gmfstckstbl_table_td_avg_stack {
      &:after {
        content: '';
        position: absolute;
        right: 0px;
        height: 100%;
        width: 3px;
        background: var(--clr-black-3);
      }
    }
  }
  .inftable_body_row {
    .inftable_td {
      --clr-dot: transparent;
      --clr-dot-hover: transparent;
    }
    &:hover {
      .inftable_td {
        --clr-dot: var(--clr-dot-hover);
      }
      .gmfstckstbl_table_td_avg_stack {
        &:after {
          display: none;
        }
      }
    }
  }
  .inftable_body_row_active {
    .inftable_td {
      --clr-dot: var(--clr-dot-hover);
    }
    .gmfstckstbl_table_td_avg_stack {
      &:after {
        display: none;
      }
    }
  }
}

@media (max-width: 1023px) {
  .gmfstckstbl_infinite-table_wrapper {
    max-height: var(--vh-14);
  }
}

@media (max-width: 720px) {
  .gmfstckstbl_tooltip {
    &_value {
      left: 0.125em;
    }
    .gmfstckstbl_tooltip_value_target {
      display: none;
    }
    &_title {
      .gmfstckstbl_tooltip_value_target {
        display: block;
      }
    }
  }
  .gmfstckstbl_infinite-table_wrapper {
    width: calc(100% + 2rem);
    margin: 0 -1rem;
  }
  .gmfstckstbl_scrollbar {
    margin: calc(2em + 2px) 0 0 0.25em;
    max-width: 1.75rem;
  }
}
</style>
